module.exports = __webpack_public_path__ + "static/media/normal.c4295917.svg";